
import { defineComponent } from 'vue';
import { AppFormRow, AppInput, AppCard, AppSelect } from '@/components';
import { AppFileUpload, AppImageHolder, AppSwitch, AppButton } from '@/components';
import { useShopItemAdd } from '@/modules/shop/model/add';
import { ShopItemType, Options } from '@/modules/shop/model/mixins';
import { ROUTE_NAME_SHOP } from '@/modules/shop/router';

export default defineComponent({
    name: ROUTE_NAME_SHOP.ADD,
    components: { AppFormRow, AppInput, AppSelect, AppCard, AppFileUpload, AppImageHolder, AppSwitch, AppButton },
    setup() {
        const { model, v$, actions, iapOptions } = useShopItemAdd();

        return { v$, model, actions, iapOptions, ShopItemType, Options };
    }
});
